import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="flex items-center justify-center h-full min-h-[50vh] w-full bg-[#090E1B] flex-grow">
            <div className="w-10 h-10 border-4 border-[#1B202F] border-t-[#00C2FF] rounded-full animate-spin"></div>
        </div>
    );
};

export default LoadingSpinner;
